/* eslint-disable react/style-prop-object */
import React from 'react';
import Button from 'shared/components/Buttons/Button';

const SecondaryButton = props => <Button {...props} variant="secondary" />;

export default SecondaryButton;
